/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPaymentDto } from '../../models/backend-payment-dto';
import { BackendPaymentRequestDto } from '../../models/backend-payment-request-dto';

export interface SubscriptionPaymentCreate$FormData$Params {
  body?: BackendPaymentRequestDto;
}

export function subscriptionPaymentCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params?: SubscriptionPaymentCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPaymentDto>> {
  const rb = new RequestBuilder(rootUrl, subscriptionPaymentCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPaymentDto>;
    }),
  );
}

subscriptionPaymentCreate$FormData.PATH = '/api/subscription/payment/';
